import { Button, Card, Divider, Form, Input } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import i18n from "i18next";
import React from "react";
import "./Login.scss";
import { useLocation } from "react-router-dom";


function ResetPwCard(props) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const verify = params.get('verify');

  return (
    <Card title={"Passwort setzen"} className="card">
      <Form
        name="reset_pw"
        className="resetPw-form"
        onFinish={props.onFinish}
      >
        <Form.Item
          name="password"
          className="form-item"
          rules={[
            {
              required: true,
              message: "Bitte Passwort eingeben",
            },
          ]}
          hasFeedback
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder={"Passwort"}
          />
        </Form.Item>

        <Form.Item
          name="confirm"
          className="form-item"
          dependencies={['password']}

          rules={[
            {
              required: true,
              message: "Bitte Passwort eingeben"
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwort stimmt nicht überein!"));
              },
            }),
          ]}
          hasFeedback
        >
          <Input
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder={"Passwort bestätigen"}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button card-first-btn"
          >
            {"Bestätigen"}
          </Button>
        </Form.Item>

      </Form>

      {/*<div className="flex-center">*/}
      {/*  <Button*/}
      {/*    className="lng-btn"*/}
      {/*    style={{ fontWeight: props.language === "en" ? "bold" : "" }}*/}
      {/*    type="link"*/}
      {/*    onClick={() => {*/}
      {/*      i18n.changeLanguage("en");*/}
      {/*      window.localStorage.setItem("language", "en");*/}
      {/*      props.setLanguage("en");*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {props.translation("english")}*/}
      {/*  </Button>*/}
      {/*  <Divider type="vertical" className="divider" />*/}
      {/*  <Button*/}
      {/*    className="lng-btn"*/}
      {/*    style={{ fontWeight: props.language === "de" ? "bold" : "" }}*/}
      {/*    type="link"*/}
      {/*    onClick={() => {*/}
      {/*      i18n.changeLanguage("de");*/}
      {/*      window.localStorage.setItem("language", "de");*/}
      {/*      props.setLanguage("de");*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {props.translation("german")}*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </Card>
  );
}

export default ResetPwCard;
